module.exports = __webpack_public_path__ + "static/media/howwork.e9f2824a.png";